module.exports = __webpack_public_path__ + "static/media/CHARGING_TERMINAL-4.39502a96.png";